import React from "react";
import Header from "./Header";
import AgreementConfig from "../agreements/config/AgreementConfig";

export default function LayoutAgreementConfig() {
  return (
    <>
      <Header />
      <AgreementConfig />
    </>
  );
}
